import { render, staticRenderFns } from "./Corredor.vue?vue&type=template&id=18963538&"
import script from "./Corredor.vue?vue&type=script&lang=js&"
export * from "./Corredor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports